import useApiWorker from 'hooks/useApiWorker';
import { KeyandSecret } from 'types/KeyAndSecret';

export async function GetEdfiCredentials(): Promise<ApiResponse<KeyandSecret>>{
    const apiWorker = useApiWorker();
    return apiWorker
    .get<KeyandSecret>(`/api/Read-Only-Creds`)
    .then((result) => {
        return{ success:true, data: result.data}
    })
    .catch((error)=>{
        return{
            success: false,
            message:error.response.data.message
        };
    });

}
